import { map, converge, head, tail, filter, prepend, compose } from 'ramda';
import columnDefVy, { columnListVy } from './columnDefVy';
import defaultColumns from '../../Utils/defaultColumns';
import { IObjektVy } from '../../../../../Types/ObjektVy';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import { IColumnDef } from '../../../../../Types/ColumnDefType';
import { objektVyGrupp } from './ObjektVyGrupp';
import ObjektVySida from './ObjectVySida';
import { objektVyLista } from './ObjektVyLista';
import { getDebugFalt } from '../../../../Dev/DebugRutin/DebugRutinUtils';

// vy som använder en lista av kolumndefinitioner och skapar ett fält per kolumn.
const columnDefsVy = (
  columndefs: readonly IColumnDef[],
  id: string
): IObjektVy =>
  ObjektVySida(id, [[objektVyGrupp(id, map(columnDefVy, columndefs), ' ')]]);

// vy som använder en lista av kolumndefinitioner och skapar ett fält per kolumn.
const inlineDefsVy = (
  columndefs: readonly IColumnDef[],
  id: string
): IObjektVy =>
  objektVyLista(
    id,
    map(
      columnListVy,
      columndefs.filter(x => !x.header)
    )
  );

// skapar en vy med defaultcolumnerna
export const defaultColumnDefsVy: IObjektVy = {
  type: 'ObjektVy',
  id: 'defaultColumns',
  info: {},
  def: (businessModel: IClientBusinessModel) =>
    columnDefsVy(defaultColumns(businessModel.CollectionName), '').def(
      businessModel
    ),
};

// skapar en vy med debugcolumnerna
export const debugColumnDefsVy: IObjektVy = {
  type: 'ObjektVy',
  id: 'defaultColumns',
  info: {},
  def: (businessModel: IClientBusinessModel) =>
    columnDefsVy(
      getDebugFalt(businessModel.CollectionName).map(x => ({
        attributeDef: x,
        caption: x,
      })),
      ''
    ).def(businessModel),
};

export const inlineColumnDefsVy: IObjektVy = {
  type: 'ObjektVy',
  id: 'inlineColumns',
  info: {},
  def: (businessModel: IClientBusinessModel) =>
    inlineDefsVy(defaultColumns(businessModel.CollectionName), '').def(
      businessModel
    ),
};

// vi gissar som default att ett objekt kan identifieras med hjälp av första kolumnen + ev. BENAMNING
const findIdColumns = converge(prepend, [
  head,
  compose(
    filter((col: any) => col.attributeDef === 'BENAMNING'),
    tail
  ),
]);

// defaultvy med tillräckliga fält för att kunna identifiera ett objekt.
// kan fungera som default för en expanderbar vy
export const defaultIdColumnsVy: IObjektVy = {
  type: 'ObjektVy',
  id: 'defaultColumns',
  info: {},
  def: (businessModel: IClientBusinessModel) =>
    columnDefsVy(
      (compose(findIdColumns, defaultColumns) as any)(
        businessModel.CollectionName
      ),
      ''
    ).def(businessModel),
};

/** @component */
export default columnDefsVy;
